import { render, staticRenderFns } from "./ComboboxSecretaria.vue?vue&type=template&id=1be42043"
import script from "./ComboboxSecretaria.vue?vue&type=script&lang=js"
export * from "./ComboboxSecretaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports